import Modal from 'react-bootstrap/Modal';
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { useEffect, useState } from 'react';
import urls from '../../constants';


export const ProductImportFile = ({
    modalShow,
    setModalShow,
    productVariant,
    setAddProduct,
    addProduct,
    productConfigVariant,
    variantsArray,
    setvariantsarray,
    HandleProductOnChange,
    setRecalculateLoading,
    productConfig,
    endcaplist }) => {
    const [excelData, setExcelData] = useState([]);
    const [file, setFile] = useState(null);
    const [excelUpdate, setExcelUpdate] = useState(false);
    const [variantsData, setVariantsData] = useState([]);
    const [productsData, setProductsData] = useState([]);
    const [errorShow, setErrorShow] = useState(null);
    useEffect(() => {
        setFile(null);
        setExcelData([]);
        setExcelUpdate(false);
        setErrorShow(null);
    }, [modalShow])

    const exportToExcel = (variantList) => {
        let accc = {}
        const data = variantList?.filter(item => item?.inputByUser === true)?.reduce((acc, item) => {
            accc[item.variantName] = "";
            return accc;
        }, {});
        // Convert JSON data to a worksheet
        const worksheet = XLSX.utils.json_to_sheet([data]);

        // Create a new workbook and append the worksheet
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

        // Generate the Excel file and trigger download
        const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
        const fileData = new Blob([excelBuffer], { type: "application/octet-stream" });
        saveAs(fileData, productConfig?.productName?.productName + "-sampleExcel.xlsx");
    };

    const handleFileChange = (event) => {
        const selectedFile = event.target.files[0];
        const isExcelFile = /\.(xls|xlsx)$/i.test(selectedFile?.name || "");

        if (selectedFile && !isExcelFile) {
            setFile(null);
            setErrorShow("Only .xls or .xlsx files are supported.");
            event.target.value = '';
            return;
        }

        setFile(selectedFile || null)
        setErrorShow(null)
        event.target.value = '';
    }

    const handleFileUpload = () => {
        if (file) {
            setErrorShow(null);
            const reader = new FileReader();

            reader.onload = (e) => {
                const arrayBuffer = e.target.result;
                const uint8Array = new Uint8Array(arrayBuffer); // Convert ArrayBuffer to Uint8Array
                // Read workbook from the Uint8Array
                const workbook = XLSX.read(uint8Array, { type: "array" });
                const sheetName = workbook.SheetNames[0]; // Get the first sheet name
                if (!sheetName) {
                    setErrorShow("The uploaded workbook does not contain any sheets.");
                    setFile(null);
                    return;
                }
                const sheet = workbook.Sheets[sheetName]; // Get sheet data

                const data = XLSX.utils.sheet_to_json(sheet); // Convert sheet data to JSON
                if (!data?.length) {
                    setErrorShow("The uploaded sheet does not contain any rows.");
                    setFile(null);
                    return;
                }
                const keys = Object.keys(data[0]);
                const headName = productConfigVariant?.filter(item => item?.inputByUser === true)
                const requiredHeadName = headName?.filter(item => urls?.VALIDATION_VARIANT_ARRAY?.includes(item?.variantId));
                const isSame = requiredHeadName.every(item1 => keys.some(item2 => item1.variantName === item2));
                const hasValidData = data?.some(row =>
                    requiredHeadName?.some(
                        headVar => row?.[headVar?.variantName] !== ""
                    )
                );

                if (isSame && data?.length > 0 && hasValidData) {
                    setRecalculateLoading(true);
                    setModalShow(false);
                    setExcelData(data); // Save the extracted data
                    AddProduct(data)
                }
                else {
                    setErrorShow("Please check the template columns and required size values.")
                    setFile(null);
                }
            };
            reader.readAsArrayBuffer(file); // Read file as ArrayBuffer
        } else {
            setErrorShow("Please upload the file")
        }
    };

    const AddProduct = (data) => {
        if (!data?.length) return;
        const newProducts = [];
        const newVariants = [];
        data.forEach((excelData) => {
            const generated = new Set();
            let uniqueNumber;
            
            do {
                uniqueNumber = Date.now() + Math.floor(Math.random() * 1000000);
            } while (generated.has(uniqueNumber));
            
            generated.add(uniqueNumber);
            
            newProducts.push({
                sid: uniqueNumber,
                id: 0,
                quoteProductId: 0,
                notes: "",
                specialDesignRequest: "",
                sdrCharges: "",
            });

            const variantDetails = productConfigVariant || productVariant;
            if (variantDetails?.length) {
                variantDetails.forEach((item) => {
                    newVariants.push({
                        sid: uniqueNumber,
                        id: 0,
                        quoteProductItemId: 0,
                        variantId: item?.variantId,
                        variantValue: urls.END_CAPS.includes(item?.variantId) ?
                            endcaplist?.find(item1 => item1?.value === excelData?.[item?.variantName]) ?
                                excelData?.[item?.variantName] || ""
                                : ""
                            : excelData?.[item?.variantName] ?? "",
                        inputByUser: item?.inputByUser,
                    });
                });
            }
        });
        const emptyList = [...variantsArray, ...newVariants]
            ?.filter(item =>
                item?.inputByUser === true &&
                item?.variantValue === "" &&
                urls?.VALIDATION_VARIANT_ARRAY?.includes(item?.variantId)
            )
            ?.map(item => item?.sid);

        setAddProduct((prev) => [
            ...prev.filter(item => !emptyList?.includes(item?.sid)),
            ...newProducts
        ]);
        setvariantsarray((prev) => [
            ...prev.filter(item => !emptyList?.includes(item?.sid)),
            ...newVariants
        ]);
        setExcelUpdate(true);
        setVariantsData(newVariants)
        setProductsData(newProducts)
    };

    useEffect(() => {
        if (excelUpdate && variantsData?.length > 0 && productsData?.length > 0) {
            
            const result = addProduct.map(user => {
                const relatedCount = variantsArray.filter(post => post.sid === user.sid).length;
                return { sid: user?.sid, count: relatedCount };
            });
            const apiCalls = addProduct.map((productItem, productIndex) =>
                Promise.resolve(HandleProductOnChange({ sid: productItem?.sid }, productIndex))
            );

            Promise.all(apiCalls)
                .then(() => {
                    setRecalculateLoading(false);
                    setExcelUpdate(false);
                    setVariantsData([])
                    setProductsData([])
                })
                .catch((error) => {
                    console.error("Error processing products:", error);
                });
        }
    }, [excelUpdate, variantsData, productsData]);


    return (<>
        <Modal
            size="sm"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            show={modalShow}
            className="upload-modal-popup"
        >
            <Modal.Header>
                <div className="product-import-header">
                    <div>
                        <h5>Import Sizes</h5>
                        <span>{productConfig?.productName?.productName || "Selected model"}</span>
                    </div>
                    <button type="button" className="product-import-close" aria-label="Close" onClick={() => setModalShow(false)}>
                        <i className="fas fa-times"></i>
                    </button>
                </div>
            </Modal.Header>
            <Modal.Body>
                {errorShow && (
                    <div className="product-import-error">{errorShow}</div>
                )}

                <div className="product-import-steps">
                    <button
                        className="product-import-template"
                        type="button"
                        onClick={() => { exportToExcel(productConfigVariant) }}
                    >
                        <i className="fas fa-file-download"></i>
                        <span>
                            Download template
                            <small>Use the generated columns for this model.</small>
                        </span>
                    </button>

                    <div className="product-import-dropzone">
                        <form id="file-upload-form" className="uploader">
                            <input
                                id="file-upload"
                                type="file"
                                name="productSizeImportFile"
                                accept=".xls,.xlsx"
                                onChange={handleFileChange}
                            />
                            <label htmlFor="file-upload" className={file ? "has-file" : ""}>
                                <span className="material-symbols-outlined upload-icon">
                                    cloud_upload
                                </span>
                                <span className="attach-label">
                                    <strong>{file?.name || "Choose Excel file"}</strong>
                                    <small>Only .xls or .xlsx files are supported.</small>
                                </span>
                            </label>
                        </form>
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <button className="btn cancel-btn" type="button" onClick={() => setModalShow(false)}>
                    Cancel
                </button>
                <button className="btn upload-btn" type="button" onClick={() => handleFileUpload()}>
                    Upload
                </button>
            </Modal.Footer>
        </Modal>
    </>
    )
}




